import PropTypes from 'prop-types'
import React from 'react'

export default function Indicador2({
  p_resultado,
  p_restaurante,
  p_data,
  p_cor
}) {
  return (
    <div className={`DashItem class-${p_cor}`}>
      <div className="linha1">{p_restaurante}</div>
      <div className="linhaNota">Pontuação:</div>
      <div className="linhaNota">{p_resultado}</div>
      <div className="linha2">
        <div className="op1">
          <div className="op1-1">Data Auditoria</div>
          <div className="op1-1">{p_data}</div>
        </div>
      </div>
    </div>
  )
}
Indicador2.propTypes = {
  p_resultado: PropTypes.string.isRequired,
  p_restaurante: PropTypes.string.isRequired,
  p_data: PropTypes.string.isRequired,
  p_cor: PropTypes.string.isRequired
}
